<ng-template #mapCompanyModalFormContent role="document" let-modal>
  <app-page-comp-header
    [hasFeature]="locationServicesFeatureGuid"
    [hierarchyFormatting]="superHierarchyEnabled"
    [initialCompanyId]="filterCompanyID"
    [showCompanyDropdown]="true"
    [showCompanyDropdownSelectAllOption]="false"
    [title]="formTitle"
    (cancelButtonOnClick)="closeForm()"
    (companyDropDownChange)="companyDropDownOnChange($event)"
  ></app-page-comp-header>

  <div class="modal-body">
    <div class="row">
      <div [className]="embeddedFormMode && !useFullPage ? 'col-3' : 'col-0'"></div>
      <div [className]="embeddedFormMode && !useFullPage ? 'col-6' : 'col-0'">
  
        <form  class="tablelist-form" autocomplete="off">
  
            <div class="row">
              <div class="col-12">
                <div class="mb-3">

                  <app-map-sim-locations #mapSimLocations
                    [companyId]="filterCompanyID"
                    [readOnlySettings]="true"
                  ></app-map-sim-locations>

                </div>
              </div>
            </div>  
        </form>
      </div>
      <div [className]="embeddedFormMode && !useFullPage ? 'col-3' : 'col-0'"></div>
    </div>
  </div>

  <app-manage-esim-modal-form #manageEsimModalForm
  ></app-manage-esim-modal-form>

</ng-template>
